import { DEPLOY_ENV } from '@/defines/env'
import { domain } from './environment/config'

export const mallApiDomain =
  DEPLOY_ENV === 'test'
    ? `https://mallapi.stage.${domain}` // 'https://mallapi.test.${domain}'
    : DEPLOY_ENV === 'stage'
    ? `https://mallapi.stage.${domain}`
    : `https://mallapi.${domain}`

export const mallDomain =
  DEPLOY_ENV === 'test'
    ? `https://mallh5.stage.${domain}` // 'https://wxtest.${domain}'
    : DEPLOY_ENV === 'stage'
    ? `https://mallh5.stage.${domain}`
    : `https://online.${domain}`

export const cashierDomain =
  DEPLOY_ENV === 'test'
    ? `https://cashier.stage.${domain}/` // 'https://cashier.test.${domain}/'
    : DEPLOY_ENV === 'stage'
    ? `https://cashier.stage.${domain}/`
    : `https://cashier.${domain}/`

export const mallEntranceDomain =
  DEPLOY_ENV === 'test'
    ? `https://mall-entrance.stage.${domain}/` // 'https://mall-entrance.test.${domain}/'
    : DEPLOY_ENV === 'stage'
    ? `https://mall-entrance.stage.${domain}/`
    : `https://mall-entrance.${domain}/`
